<template>
  <div>
    <el-row :span="24" :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="12">
        <el-date-picker
          v-model="date"
          :clearable='false'
          format="d MMM yy"
          value-format="MM-dd-yyyy"
          type="date"
          placeholder="As At">
        </el-date-picker>
      </el-col>
      <el-col :span="12" style="display: flex; justify-content: flex-end;">
        <el-button :disabled="!data.length" type="success" size="default" @click="addCreditableVAT">Create Esubmission Files</el-button>
      </el-col>
    </el-row>

    <el-table
      :data="data"
      row-key="date"
      default-expand-all
      max-height="650"
      size="small"
      :row-class-name="tableRowClassName"
      :empty-text="$t('general_noData')"
      style="width: 100%">
      <el-table-column
        fixed
        prop="date"
        label="Date">
        <template slot-scope="scope">
          <span v-if="!scope.row.isParent">{{ scope.row.date }}</span>
          <el-tooltip v-else :content="scope.row.info" placement="top">
            <span>{{ scope.row.date }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        prop="id"
        label="ID"
        align="center">
        <template slot-scope="scope">
          <div v-if="!scope.row.isParent">
            <strong @click="cellClickID(scope.row)" style="color: #409EFF; cursor: pointer;">{{scope.row.id}}</strong>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        prop="entrytype"
        label="Entry Type"
        align="center">
      </el-table-column>
      <el-table-column
        width="120"
        prop="description"
        label="Description"
        align="center">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.description"
            placement="top"
            title="Description"
            width="400"
            trigger="click"
            :content="scope.row.description">
            <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        prop="createbyName"
        label="Created By">
      </el-table-column>
      <el-table-column
        width="120"
        label="Gross Amt"
        align="right">
        <template slot-scope="scope">
          <div v-text="formatPrice(scope.row.grossamount)"></div>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        label="Tax Amt"
        align="right">
        <template slot-scope="scope">
          <div v-text="formatPrice(scope.row.taxamount)"></div>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        label="Tax Code"
        align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.viewTaxCode">
            {{ scope.row.viewTaxCode }}
          </div>
          <div v-else>{{ scope.row.taxcode }}</div>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        prop="sourceDoc"
        label="Source Doc."
        align="center">
        <template slot-scope="scope">
          <div v-if="!scope.row.isParent">
            <el-checkbox disabled v-model="scope.row.sourceDoc"></el-checkbox>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        prop="clientstatus"
        label="Status"
        align="center">
      </el-table-column>
      <el-table-column
        width="120"
        prop="report"
        label="Report"
        align="center">
        <template slot-scope="scope">
          <div v-if="!scope.row.isParent">
            <el-checkbox :disabled="scope.row.reported" v-model="scope.row.report"></el-checkbox>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        prop="reported"
        label="Reported"
        align="center">
        <template slot-scope="scope">
          <div v-if="!scope.row.isParent">
            <el-checkbox disabled v-model="scope.row.reported"></el-checkbox>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <editJournalEntryModal @updateList="getList" :showInfo="false" ref="editJournalEntryModal"/>

  </div>
</template>

<script>
  import axios from 'axios'
  let moment = require('moment');
  import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'
  import notification from '@/notification/notification.js'

  export default {
    name: 'Creditable',
    components: {
      editJournalEntryModal
    },
    data() {
      return {
        date: moment().format("MM-DD-YYYY"),
        data: [],
      }
    },
    methods: {
      cellClickID(row) {
        let rowItem = { ...row }
        rowItem.id = rowItem.transactionid
        this.$refs['editJournalEntryModal'].openModalFromJournalEntry(rowItem)
      },
      getTransactionIdArr() {
        // Используем map для итерации по каждому объекту в массиве
        const transactionIds = this.data.map(obj => {
          // Фильтруем дочерние элементы с report: true для каждого объекта
          const childrenWithReport = obj.children.filter(child => child.report === true && child.reported === false);
          // Извлекаем transactionid для отфильтрованных элементов
          const transactionIds = childrenWithReport.map(child => child.teid);
          return transactionIds;
        });

        return transactionIds.flat(); // Используем flat для объединения в один массив
      },
      async addCreditableVAT() {
        const arr = await this.getTransactionIdArr()
        if (arr.length === 0) {
          this.$message({
            showClose: true,
            message: 'Warning, no transaction selected.',
            type: 'warning'
          });
          return
        }
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.post(`/api/v1/taxation-export/generate`, {
            companyId: +this.$route.query.companyId,
            endDate: this.date,
            typeId: 2,
            transactionIdList: this.getTransactionIdArr()
          })
          notification({title: 'Success', message: 'Esubmission file successfully generated', type: 'success'})
          loader.hide()
          this.loadList()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      loadList() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          // .get(`api/v1/account/taxAccountsResultClientsSummary?companyId=93&endDate=04-16-2024`)
          .get(`api/v1/account/taxAccountsResultClientsSummary?companyId=${this.$route.query.companyId}&endDate=${this.date}`)
          .then(response => {
            this.data = response.data.data
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      tableRowClassName({row, rowIndex}) {
        return 'cursor-pointer';
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
    },
    watch:{
      'date': function (val) {
        this.loadList()
      }
    },
  }
</script>

<style lang="scss" scoped>
.data-hide {
  /deep/.el-table__body-wrapper {
    display: none;
  }
}
/deep/.el-table .bg-row {
  background: #f2f4f7;
}
</style>